import * as d3 from "d3"
import { useRef, useEffect, useState } from "react"

const graphLine = (svg, data, color, xScale, yScale) => {
  svg
    .append("g")
    .selectAll("path")
    .data([data])
    .join("path")
    .attr(
      "d",
      d3
        .line(
          (d) => xScale(d.x),
          (d) => yScale(d.y)
        )
        .curve(d3.curveMonotoneX)
    )
    .style("fill", "none")
    .style("stroke-width", 6)
    .style("stroke", color)
}

const LineGraph = ({ data, colors }) => {
  const svgRef = useRef()
  const [svgWidth, setSvgWidth] = useState(0)
  const [svgHeight, setSvgHeight] = useState(0)
  const bufferBottom = svgHeight * 0.074
  const bufferTop = svgHeight * 0.01
  const bufferWidth = svgWidth * 0.06

  useEffect(() => {
    if ("buses_incoming" in data) {
      const inBuses = data.buses_incoming.map((d, i) => ({ y: d.y, x: i }))
      const outBuses = data.buses_outgoing.map((d, i) => ({ y: d.y, x: i }))
      const maxBuses = Math.max(
        ...inBuses.map((d) => d.y),
        ...outBuses.map((d) => d.y)
      )
      const inOrders = data.orders_incoming.map((d, i) => ({ y: d.y, x: i }))
      const outOrders = data.orders_outgoing.map((d, i) => ({ y: d.y, x: i }))
      const maxOrders = Math.max(
        ...inOrders.map((d) => d.y),
        ...outOrders.map((d) => d.y)
      )
      const xAxisTicks = data.buses_incoming.map((d) => d.x)

      const svg = d3.select(svgRef.current).select("svg")
      svg.selectAll("*").remove()
      setSvgWidth(svgRef.current.clientWidth)
      setSvgHeight(svgRef.current.clientHeight)
      svg.attr("width", "100%").attr("height", "100%")

      // y axis Buses
      const yScaleBuses = d3
        .scaleLinear()
        .domain([maxBuses + 2, 0])
        .range([bufferTop, svgHeight - bufferBottom])
        .nice()
      const yAxisBuses = d3.axisLeft(yScaleBuses).tickSizeOuter(0)
      svg
        .append("g")
        .attr("class", "warehouse-graph-labels")
        .attr("transform", `translate(${bufferWidth}, 0)`)
        .call(yAxisBuses)
      svg
        .append("text")
        .attr("text-anchor", "start")
        .attr("class", "warehouse-graph-labels")
        .attr("x", -(bufferTop + bufferBottom + svgHeight) / 2)
        .attr("y", bufferWidth - svgWidth * 0.035)
        .text("Buses")
        .attr("transform", "rotate(-90)")
        .style("font-size", "24px")

      // y axis Orders
      const yScaleOrders = d3
        .scaleLinear()
        .domain([maxOrders + 15, 0])
        .range([bufferTop, svgHeight - bufferBottom])
        .nice()
      const yAxisOrders = d3.axisRight(yScaleOrders).tickSizeOuter(0)
      svg
        .append("g")
        .attr("class", "warehouse-graph-labels")
        .attr("transform", `translate(${svgWidth - bufferWidth}, 0)`)
        .call(yAxisOrders)
      svg
        .append("text")
        .attr("text-anchor", "end")
        .attr("class", "warehouse-graph-labels")
        .attr("x", (bufferTop + bufferBottom + svgHeight) / 2)
        .attr("y", -(svgWidth - bufferWidth + svgWidth * 0.035))
        .attr("transform", "rotate(90)")
        .text("Orders")
        .style("font-size", "24px")

      // x axis ticks
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ]
      let formattedTicks = []
      for (let i = 0; i <= inBuses.length - 1; i++) {
        const newDate = xAxisTicks[i].split("-")
        const month = months[+newDate[1] - 1]
        const day = newDate[2]
        const tick = month + " " + day
        formattedTicks.push(tick)
      }
      // x axis
      const xAxisScale = d3
        .scaleLinear()
        .domain([0, xAxisTicks.length - 1])
        .range([bufferWidth, svgWidth - bufferWidth])
        .nice()
      const xAxis = d3
        .axisBottom(xAxisScale)
        .tickFormat((i) => formattedTicks[i])
        .ticks(formattedTicks.length)
      svg
        .append("g")
        .attr("class", "warehouse-graph-x-axis")
        .attr("transform", `translate(0, ${svgHeight - bufferBottom})`)
        .call(xAxis)

      graphLine(
        svg,
        inBuses,
        colors.incomingBuses.dark,
        xAxisScale,
        yScaleBuses
      )
      graphLine(
        svg,
        outBuses,
        colors.outgoingBuses.dark,
        xAxisScale,
        yScaleBuses
      )
      graphLine(
        svg,
        inOrders,
        colors.incomingOrders.dark,
        xAxisScale,
        yScaleOrders
      )
      graphLine(
        svg,
        outOrders,
        colors.outgoingOrders.dark,
        xAxisScale,
        yScaleOrders
      )
    }
  }, [data, svgWidth, svgHeight])
  return (
    <div style={{ height: "40vh", width: "100%%" }} ref={svgRef}>
      <svg></svg>
    </div>
  )
}

export default LineGraph
